var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"items":_vm.datas,"label":"Sınav Türü","item-text":(item) => item.Name,"item-value":(item) => item.Id,"outlined":"","clearable":"","hide-details":"","dense":"","filter":_vm.filterTR}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }